<template>
        <tr>
            <td class="icon release-model">
                <i :class="isSelected()" @click="setRelease()"></i>
            </td>
            <td class="images release-model">
                <img :src="item.image" alt="">
            </td>
            <td class="release-model">
                <div class="top font-normal">{{ item.name | maxLength}}</div>
                <div class="font-normal">{{ item.performer | maxLength }}</div>
                <div class="font-small">{{ item.promoter }} Titel mit Beteiligung</div>
            </td>
        </tr>
</template>

<script>
    import modals from '../../data/modals'
  export default {
    props: ['item'],
    data () {
      return {
        selected: modals.release
      }
    },
    methods: {
      isSelected() {
        if (this.selected.includes(this.item.id)) {
          return 'fas fa-check-circle'
        } else {
          return 'far fa-circle'
        }
      },
      setRelease() {
        if(modals.release.includes(this.item.id)){
          modals.release.splice(modals.release.indexOf(this.item.id), 1);
        } else {
          modals.release.push(this.item.id)
        }

        this.selected = modals.release
      }
    }

  }
</script>
